/**
 * Created by cxh on 8/10/2016.
 */
(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .controller('TrackController', TrackController);

  /* @ngInject */
  function TrackController($scope, customerService, AuthenticationService, updaterService, $interval) {
    var vm = this;
    var failuresInterval = null;
    vm.sidebarModel = createSideBarModel();

    $scope.$on('$destroy', function() {
      if(failuresInterval !== null) {
        $interval.cancel(failuresInterval);
      }
    });

    activate();

    ////////////////
    function activate() {
      $scope.$watch(function () {
        return AuthenticationService.IsLogin();
      }, function (data) {
        if (data) {
          updaterService.doUpdate();
        }
      }, true);
    }

    function createSideBarModel() {

      var model = {};

      model.showUserPanel = false;

      // menu items.
      model.treeItems = customerService.getCustomerSideBarMenu();
      // periodically update the sidebar failures count (Every 5 mins)
      updateFailuresCount(model);
      failuresInterval = $interval(function () {updateFailuresCount(model);}, 300000);

      // search panel.
      model.showSearchPanel = false;

      return model;
    }

    function updateFailuresCount(model) {
      customerService.getVehicleFailuresCount().then(function(data) {
        if(data.dataList !== null) {
          var fmsItem = model.treeItems.find(item => item.text === 'sidebar.betotrack.fms');
          if(fmsItem !== null) {
            var failuresCount = data.dataList[0].telltalecount;
            if(failuresCount > 99) {
              fmsItem.failures = '99+';
            } else {
              fmsItem.failures = failuresCount;
            }
          }
        }
      });
    }
  }

})();





// WEBPACK FOOTER //
// ./.tmp/components/track/trackController.js